import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Paper } from "@components/paper";
import ContentWrapper from "../../components/contentWrapper";
import VerifyRouter from "./containers/router";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import { ProgressionBar } from "../../components/breadCrumb/progressionBar";
import ErrorModal from "../PersonalLoan/components/errorModal/errorModal";
import { VerifyRouteController } from "./routing/verifyRouteController";
import { useAccountExternalId, useOnMount } from "@hooks";
import actions from "@redux/verify/actions";
import useGtmPageEvent from "@hooks/useGtmPageEvent";
import startUpActions from "@redux/startup/actions";
import { convertDomainToCorrespondingBrand } from "@src/utils/helpers/convertDomainToCorrespondingBrand";
import { isNotNullOrEmpty } from "@src/utils/helpers/stringHelper";
import { PUBLIC_ROUTE } from "@src/route.constants";

const restartFormHandler = () => {
  window.location.reload();
}

const useExternalIdDispatch = () => {
  const dispatch = useDispatch();
  const accountExternalId = useAccountExternalId();
  useOnMount(() => {
    dispatch(actions.setVerifyExternalId({ accountExternalId }));
  });
};

export const Verify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accountExternalId = useAccountExternalId();
  const { submitFailed, retrieveVerify } = useSelector(store => store.verify);
  const { brand } = useSelector(state => state.loanForm.initialValue);
  const convertedBrandName = convertDomainToCorrespondingBrand();

  useExternalIdDispatch();
  useGtmPageEvent();
  
  useEffect(() => {
    const brandIsMismatched =
      isNotNullOrEmpty(brand) &&
      isNotNullOrEmpty(convertedBrandName) &&
      brand !== convertedBrandName;

    if (brandIsMismatched) {
      navigate(PUBLIC_ROUTE.LANDING);
    }
    
  }, [brand, convertedBrandName, navigate, retrieveVerify, accountExternalId]);

  useEffect(() => {
    dispatch(startUpActions.fillForm());
  }, [dispatch]);

  return (
    <PageWrapper renderHeaderBottom={() => <ProgressionBar percent={0} />}>
      <Paper>
        <ContentWrapper>
          <VerifyRouter />
        </ContentWrapper>
      </Paper>
      <ErrorModal
        visible={submitFailed}
        restart={() => restartFormHandler()}
        buttonText="Try Again"
      />
      <VerifyRouteController />
    </PageWrapper>
  )
};

export default Verify;